import React from 'react';
import { FormHeader } from '@snsw-gel/react';
import styled from 'styled-components';

import config from '../../../config/config';

const FormHeaderWrapper = styled.div`
    margin-bottom: -2.5rem;
`;

export interface IHeaderNoStepperProps {
    readonly headerTitle?: string;
}

const HeaderNoStepper = (props: IHeaderNoStepperProps) => {
    const headerTitle: string = props.headerTitle ?? 'Application submitted for assessment';

    return (
        <FormHeaderWrapper>
            <FormHeader
                label={config.appTitle}
                title={headerTitle}
            />
        </FormHeaderWrapper>
    );
};

export default HeaderNoStepper;
